/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_All_Systems_OperationalInputs */

const en_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All systems operational`)
};

const ar_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الأنظمة تعمل`)
};

const bn_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব সিস্টেম চালু আছে`)
};

const de_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Systeme betriebsbereit`)
};

const es_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los sistemas operativos`)
};

const fr_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les systèmes opérationnels`)
};

const pt_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os sistemas operacionais`)
};

const zh_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有系统均可运行`)
};

const tr_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm sistemler çalışır durumda`)
};

const ru_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все системы в рабочем состоянии`)
};

const pl_footer_all_systems_operational = /** @type {(inputs: Footer_All_Systems_OperationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie systemy działają`)
};

/**
* | output |
* | --- |
* | "All systems operational" |
*
* @param {Footer_All_Systems_OperationalInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_all_systems_operational = /** @type {((inputs?: Footer_All_Systems_OperationalInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_All_Systems_OperationalInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_footer_all_systems_operational(inputs)
	if (locale === "bn") return bn_footer_all_systems_operational(inputs)
	if (locale === "de") return de_footer_all_systems_operational(inputs)
	if (locale === "es") return es_footer_all_systems_operational(inputs)
	if (locale === "fr") return fr_footer_all_systems_operational(inputs)
	if (locale === "pt") return pt_footer_all_systems_operational(inputs)
	if (locale === "zh") return zh_footer_all_systems_operational(inputs)
	if (locale === "tr") return tr_footer_all_systems_operational(inputs)
	if (locale === "ru") return ru_footer_all_systems_operational(inputs)
	if (locale === "pl") return pl_footer_all_systems_operational(inputs)
	return en_footer_all_systems_operational(inputs)
});